exports.productParams = {
  // urlPrefix: "/sacs-en-tissu/",
  urlPrefix: "/",
};

exports.productUrl = (product) => {
  return `${this.productParams.urlPrefix}${product.categories.length ? product.categories[0].slug + "/" : ""
    }${product.slug}/`;
};

exports.createProducts = async ({ graphql, actions }) => {
  const { createPage, createRedirect } = actions;
  const result = await graphql(
    `
      {
        products: allStrapiProduct(filter: { status: { eq: "published" } }) {
          edges {
            node {
              slug
              status
              categories {
                id
                slug
              }
            }
          }
        }
        allStrapiCategory {
          edges {
            node {
              slug
            }
          }
        }
      }
    `
  );

  if (result.errors) {
    throw result.errors;
  }

  const products = result.data.products.edges;
  const allCategories = result.data.allStrapiCategory.edges.map(edge => edge.node);
  const ProductTemplate = require.resolve("./src/templates/product.js");


  products.forEach((product, index) => {
    const canonicalPath = this.productUrl(product.node);


    createPage({
      path: product.node.slug.includes('%') ? decodeURIComponent(canonicalPath) : canonicalPath,
      component: ProductTemplate,
      context: {
        ...product.node,
      },
    });

    // root redirect (old wordpress pb)
    const { slug } = product.node;
    const fromRootPath = `${this.productParams.urlPrefix}${slug}`;
    createRedirect({
      fromPath: fromRootPath,
      toPath: canonicalPath,
      isPermanent: true,
      redirectInBrowser: true,
      force: true,
    });

    // category redirects
    const { categories } = product.node;
    const primaryCategorySlug = categories.length ? categories[0].slug : null;
    allCategories.forEach((category) => {
      if (category.slug === primaryCategorySlug) return;
      const fromPath = `${this.productParams.urlPrefix}${category.slug}/${slug}/`;
      if (fromPath === canonicalPath) return;
      createRedirect({
        fromPath,
        toPath: canonicalPath,
        isPermanent: true,
        redirectInBrowser: true,
        force: true,
      });
    });
  });
};
